import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthGuardService } from './services/auth-guard.service';
import { LoginComponent } from './login/login.component';
import { SettingsConfigurationComponent } from './settings-configuration/settings-configuration.component';
import { LayoutModule } from '../layouts/layout.module';
import { LayoutComponent } from '../layouts/layout.component';
import { PhysicalInventoryModule } from '../physicalInventory/physicalInventory.module';
import { ButtonModule } from '../button/button.module';
import { TransferModule } from '../transfers/transfer.module';
import { InTransitModule } from '../in-transit/in-transit.module';
import { DocumentApprovalModule } from '../document-approval/document-approval.module';
import { AllLocationsComponent } from '../shared/all-locations/all-locations.component';
import { PurchaseOrderModule } from '../purchase-order/purchase-order.module';
import { OfflineModule } from '../offline/offline.module';
import { AboutModule } from '../about/about.module';
import { ItemDetailsHistoryComponent } from '../shared/item-details-history/item-details-history.component';
import { NoMathComponent } from '../shared/no-math/no-math.component';
import { AuthorizationDeniedComponent } from './authorization/authorization-denied/authorization-denied.component';
import { OfflineNoDataComponent } from '../shared/offline-no-data/offline-no-data.component';
const isIframe = window !== window.parent && !window.opener;

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent

  },
  {
    path: 'settings-configuration',
    component: SettingsConfigurationComponent
  },
  {
    path: 'id_token',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    children: [
    {path: 'auth-denied', component: AuthorizationDeniedComponent },
    {path: 'OfflineNotSupported', component: OfflineNoDataComponent },
    { path: 'admin', loadChildren: () => import('../admin/admin.module').then(m => m.AdminModule) },
    { path: 'dashboard', loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule) },
    { path: 'inventory', loadChildren: () => import('../inventory/inventory.module').then(m => m.InventoryModule) },
      {
        path: 'physicalInventory', loadChildren: () =>
          import('../physicalInventory/physicalInventory.module').then(m => m.PhysicalInventoryModule)
      },
    // { path: 'report', loadChildren: '../reports/report.module#physicalInventoryModule' },
      { path:  'spoilage', loadChildren:  () => import('../spoilage/spoilage.module').then(m => m.SpoilageModule)  },
      { path: 'message', loadChildren:  () => import('../message/message.module').then(m => m.MessageModule)  },
      { path: 'receiving', loadChildren:  () => import('../receiving/receiving.module').then(m => m.ReceivingModule)  },
    { path: 'setting', loadChildren: () => import('../settings/setting.module').then(m => m.SettingModule) },
    { path: 'passcode', loadChildren: () => import('../PasscodeConfiguration/passcoderouting.module').then(m => m.PasscoderoutingModule) },
    { path: 'form', loadChildren: () => import('../form/form.module').then(m => m.FormModule) },
    { path: 'button', loadChildren: () => import('../button/button.module').then(m => m.ButtonModule) },
    { path: 'transfer', loadChildren: () => import('../transfers/transfer.module').then(m => m.TransferModule) },
    { path: 'in-transit', loadChildren: () => import('../in-transit/in-transit.module').then(m => m.InTransitModule) },
    { path: 'transfer-acknowledgement', loadChildren: () => import('../transfer-acknowledgement/transfer-acknowledgement.module').then(m => m.TransferAcknowledgementModule) },
    { path: 'document', loadChildren: () => import('../document-approval/document-approval.module').then(m => m.DocumentApprovalModule) },
    {path: 'purchaseOrder', loadChildren: () => import('../purchase-order/purchase-order.module').then(m => m.PurchaseOrderModule)},
    {path: 'offline', loadChildren: () => import('../offline/offline.module').then(m => m.OfflineModule)},
    {path: 'about', loadChildren: () => import('../about/about.module').then(m => m.AboutModule)},
    {path: 'alllocations', component: AllLocationsComponent},
    {path: 'noMath', component: NoMathComponent},
    {path: 'historyDetails', component: ItemDetailsHistoryComponent},
    { path: 'manageLicence', loadChildren:  () => import('../manage-licenses/manage-licenses.module').then(m => m.ManageLicensesModule)  },
    ]
  },
  {
    path: '**',
    component: NotFoundComponent
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled'  })],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
